import React from 'react';
import { Trash2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface RotatingTrashIconProps {
  className?: string;
  size?: number;
  hoverGroup?: string;
}

export const RotatingTrashIcon: React.FC<RotatingTrashIconProps> = ({
  className,
  size,
  hoverGroup,
}) => {
  const hoverRotate = hoverGroup
    ? `group-hover/${hoverGroup}:rotate-[30deg]`
    : 'group-hover:rotate-[30deg]';

  return (
    <Trash2
      size={size}
      className={cn(
        'h-4 w-4 shrink-0 transition-transform duration-300',
        hoverRotate,
        className,
      )}
    />
  );
};
